"use client";

import React from "react";
import { Maximize2 } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const portfolioItems = [{
  id: 1,
  title: "Master Suite Vanity",
  location: "Broward County, FL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622208/img/side_return_extension_bw.png",
  ratio: 4 / 3
}, {
  id: 2,
  title: "Interior Painting",
  location: "Fort Lauderdale, FL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622208/img/luxury_kitchen_build_bw.png",
  ratio: 3 / 4
}, {
  id: 3,
  title: "Residential Demolition",
  location: "Broward County, FL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622208/img/house_refurbishment_bw.png",
  ratio: 16 / 9
}, {
  id: 4,
  title: "Drywall Restoration",
  location: "Fort Lauderdale, FL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622208/img/dormer_loft_conversion_bw.png",
  ratio: 1 / 1
}, {
  id: 5,
  title: "Exterior Pressure Wash",
  location: "Broward County, FL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622208/img/double_storey_extension_bw.png",
  ratio: 3 / 4
}, {
  id: 6,
  title: "Project Management",
  location: "South Florida Area",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622208/img/attic_conversion_bw.png",
  ratio: 4 / 3
}];
export default function ThePortfolio() {
  return <section data-section-id="130475" id="proven-results" className="bg-background text-foreground py-24 px-6 md:px-12 border-y border-border">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-8 border-b border-border pb-8">
          <div>
            <h2 className="text-4xl md:text-6xl font-default uppercase tracking-tighter mb-4 text-foreground">
              Proven Results
            </h2>
            <p className="text-muted-foreground max-w-xl font-mono text-xs uppercase tracking-widest leading-relaxed">
              A technical showcase of drywall precision, professional painting,
              and expert project management for South Florida properties.
            </p>
          </div>
          <div className="hidden md:block">
            <div className="w-24 h-2 bg-primary"></div>
          </div>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {portfolioItems.map((item, i) => <div data-index={i} key={item.id} className="break-inside-avoid">
              <Dialog>
                <DialogTrigger asChild>
                  <div className="group relative overflow-hidden cursor-pointer border-2 border-border bg-muted rounded-sm transition-colors hover:border-primary">
                    <AspectRatio ratio={item.ratio}>
                      <img src={item.image} alt={item.title} className="object-cover w-full h-full grayscale transition-transform duration-700 ease-in-out group-hover:scale-105" />
                      <div className="absolute inset-0 bg-secondary/90 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-between p-6">
                        <div className="flex justify-end">
                          <div className="bg-primary text-primary-foreground p-2 rounded-sm">
                            <Maximize2 className="w-5 h-5" />
                          </div>
                        </div>
                        <div className="border-l-4 border-primary pl-4">
                          <h3 className="text-xl md:text-2xl font-default uppercase tracking-tight text-secondary-foreground mb-2">
                            {item.title}
                          </h3>
                          <p className="font-mono text-xs text-secondary-foreground/70 uppercase tracking-widest">
                            {item.location}
                          </p>
                        </div>
                      </div>
                    </AspectRatio>
                  </div>
                </DialogTrigger>
                <DialogContent className="max-w-5xl p-0 bg-background border-2 border-primary rounded-sm overflow-hidden">
                  <DialogHeader className="sr-only">
                    <DialogTitle>{item.title}</DialogTitle>
                    <DialogDescription>{item.location}</DialogDescription>
                  </DialogHeader>
                  <div className="relative w-full h-[70vh] md:h-[85vh] bg-muted">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain grayscale" />
                    <div className="absolute bottom-0 left-0 right-0 p-6 bg-background/95 backdrop-blur-md border-t-2 border-primary flex flex-col md:flex-row justify-between items-start md:items-center gap-2">
                      <span className="text-xl font-default uppercase tracking-tight text-foreground">
                        {item.title}
                      </span>
                      <span className="font-mono text-sm text-muted-foreground uppercase tracking-widest">
                        {item.location}
                      </span>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}